import * as yup from 'yup'

import i18n from '../i18n'

const tMessage = (key: string, fallback: string) => () => i18n.t(key, fallback) || fallback

export const RepeatPasswordInputSchema = yup.object().shape({
  repeatPassword: yup
    .string()
    .required(tMessage('passwordIsRequired', 'Password is required'))
    .oneOf(
      [yup.ref('password')],
      tMessage('repeatPasswordValidation', 'Field must be the same as Password.'),
    ),
})
